import React, { useState, useEffect, useCallback } from 'react';
import { deleteService, updateService } from '../services/api';
import { useNavigate } from 'react-router-dom';
import {
  getServices, getSlaReport, getMaintenances,
  getAvailability, getResponseTime, getLogs, getDeletedServices, restoreService,
  hardDeleteService,
  getUsers, createUser, updateUser, deleteUser,   // ← ajout
} from '../services/api';
import { useSocket } from '../hooks/useSocket';
import ServiceCard from '../components/ServiceCard';
import ApiCard from '../components/ApiCard';
import LogTerminal from '../components/LogTerminal';
import CalendarView from '../components/CalendarView';
import SlaReport from '../components/SlaReport';
import CreateServiceModal from '../components/CreateServiceModal';
import EditServiceModal from '../components/EditServiceModal';

const C = {
  navy: '#1B2A4A', blue: '#2563EB', gold: '#C9A84C',
  white: '#fff', surface: '#F7F9FD', green: '#16A34A',
  orange: '#EA580C', red: '#DC2626', gray: '#64748B',
};

const TABS = [
  { id: 'apps',       label: '🏦 Applications' },
  { id: 'apis',       label: '🔌 APIs'          },
  { id: 'logs',       label: '📋 Logs'          },
  { id: 'cal',        label: '📅 Maintenance'   },
  { id: 'sla',        label: '📊 Rapports SLA'  },
  { id: 'parametres', label: '⚙️ Paramètres'    },
];

const PARAM_MENU = [
  { id: 'services',      label: '🖥️ Services'     },
  { id: 'categories',    label: '🗂️ Catégories'   },
  { id: 'corbeille',     label: '🗑️ Corbeille'    },
  { id: 'utilisateurs',  label: '👥 Utilisateurs'  },
];

function groupByCategory(services) {
  return services.reduce((acc, svc) => {
    if (!acc[svc.category]) acc[svc.category] = [];
    acc[svc.category].push(svc);
    return acc;
  }, {});
}

/* ── Onglet Paramètres ─────────────────────────────────────────────────────── */
function ParametresTab({ user, services, onDelete, onRestore, deletedServices, onCreateService, onDeletePermanent }) {
  const [paramTab, setParamTab] = useState('services');
  const [deleteCatModal, setDeleteCatModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);

  // ── États utilisateurs (ici dans ParametresTab, pas dans Dashboard) ──
  const [users,       setUsers]       = useState([]);
  const [showAddUser, setShowAddUser] = useState(false);
  const [editUser,    setEditUser]    = useState(null);
  const [newUser,     setNewUser]     = useState({ fullName: '', email: '', password: '', role: 'operator' });
  const [deleteUserModal, setDeleteUserModal] = useState(null); 

  // Chargement des utilisateurs quand on arrive sur l'onglet
  useEffect(() => {
    if (paramTab === 'utilisateurs') {
      getUsers()
        .then(res => setUsers(res.data?.data ?? res.data ?? []))
        .catch(err => console.error('Erreur getUsers:', err));
    }
  }, [paramTab]);

  const navigate = useNavigate();

  const allCategories = [...new Set(services.map(s => s.category).filter(Boolean))];

  const handleDeleteCategory = (cat) => {
    setCategoryToDelete(cat);
    setDeleteCatModal(true);
  };

  const confirmDeleteCategory = () => {
    if (!categoryToDelete) return;
    setDeleteCatModal(false);
    setCategoryToDelete(null);
  };

  const serviceCountForCat = (cat) => services.filter(s => s.category === cat).length;

  const sideBtn = (id) => ({
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '10px 14px', borderRadius: 8, border: 'none',
    background: paramTab === id ? '#EFF6FF' : 'transparent',
    color: paramTab === id ? C.blue : '#374151',
    fontWeight: paramTab === id ? 600 : 400,
    fontSize: 13, cursor: 'pointer', width: '100%', textAlign: 'left',
    borderLeft: paramTab === id ? `3px solid ${C.blue}` : '3px solid transparent',
  });

  return (
    <div style={{ display: 'flex', gap: 0, minHeight: 500 }}>

      {/* ── Menu gauche ── */}
      <div style={{
        width: 200, flexShrink: 0,
        background: '#fff', borderRadius: '12px 0 0 12px',
        borderRight: '1px solid #E2E8F0', padding: '16px 10px',
      }}>
        <div style={{ fontSize: 10, fontWeight: 700, color: '#94A3B8',
                      textTransform: 'uppercase', letterSpacing: 1,
                      marginBottom: 10, paddingLeft: 4 }}>
          Paramètres
        </div>
       {PARAM_MENU.map(m => {
          if (m.id === 'utilisateurs' && user?.role !== 'admin') return null;
          return (
            <button key={m.id} style={sideBtn(m.id)} onClick={() => setParamTab(m.id)}>
              {m.label}
            </button>
          );
        })}
      </div>

      {/* ── Contenu droite ── */}
      <div style={{
        flex: 1, background: '#fff',
        borderRadius: '0 12px 12px 0', padding: 24,
      }}>

        {/* SERVICES */}
        {paramTab === 'services' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between',
                          alignItems: 'center', marginBottom: 16 }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 700, color: C.navy }}>🖥️ Services</div>
                <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 2 }}>
                  {services.length} service(s) enregistré(s)
                </div>
              </div>
              <button
                onClick={onCreateService}
                style={{ background: C.blue, color: '#fff', border: 'none',
                         borderRadius: 8, padding: '8px 16px', fontSize: 12,
                         fontWeight: 600, cursor: 'pointer' }}>
                + Nouveau
              </button>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  {['Nom', 'Catégorie', 'URL', 'Méthode', 'Statut', ''].map(h => (
                    <th key={h} style={{ padding: '8px 10px', textAlign: 'left',
                                         fontSize: 10, fontWeight: 600, color: '#94A3B8',
                                         textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {services.map(svc => (
                  <tr key={svc.id} style={{ borderBottom: '1px solid #F8FAFC' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#F8FAFC'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 10px', fontWeight: 600, color: C.navy }}>{svc.name}</td>
                    <td style={{ padding: '10px 10px', color: '#64748B' }}>
                      <span style={{ background: '#F1F5F9', borderRadius: 4,
                                     padding: '2px 8px', fontSize: 11 }}>{svc.category}</span>
                    </td>
                    <td style={{ padding: '10px 10px', color: '#64748B', fontSize: 11,
                                  maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap' }}>{svc.check_url}</td>
                    <td style={{ padding: '10px 10px', color: '#64748B' }}>{svc.check_method || 'GET'}</td>
                    <td style={{ padding: '10px 10px' }}>
                      <span style={{
                        background: svc.last_status === 'OK' ? '#DCFCE7' : svc.last_status === 'DOWN' ? '#FEE2E2' : '#FEF9C3',
                        color: svc.last_status === 'OK' ? '#16A34A' : svc.last_status === 'DOWN' ? '#DC2626' : '#92400E',
                        borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 600,
                      }}>{svc.last_status || '—'}</span>
                    </td>
                    <td style={{ padding: '10px 10px' }}>
                      <button
                        onClick={() => onDelete(svc.id)}
                        style={{ background: '#FEF2F2', border: '1px solid #FECACA',
                                  color: '#DC2626', borderRadius: 6, padding: '4px 10px',
                                  fontSize: 11, cursor: 'pointer' }}>
                        🗑️ Supprimer
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* CATÉGORIES */}
        {paramTab === 'categories' && (
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.navy, marginBottom: 4 }}>
              🗂️ Catégories
            </div>
            <div style={{ fontSize: 12, color: '#94A3B8', marginBottom: 20 }}>
              {allCategories.length} catégorie(s) utilisée(s)
            </div>

            {allCategories.length === 0 ? (
              <div style={{ color: '#94A3B8', fontSize: 13, textAlign: 'center', paddingTop: 40 }}>
                Aucune catégorie trouvée
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12 }}>
                {allCategories.map(cat => {
                  const count = serviceCountForCat(cat);
                  const hasServices = count > 0;
                  return (
                    <div key={cat} style={{
                      background: '#F8FAFC', borderRadius: 10,
                      padding: '16px 18px', border: '1px solid #E2E8F0',
                      position: 'relative',
                    }}>
                      <div style={{ fontSize: 14, fontWeight: 600, color: C.navy, marginBottom: 4, paddingRight: 28 }}>
                        {cat}
                      </div>
                      <div style={{ fontSize: 12, color: '#64748B' }}>
                        {count > 0
                          ? `${count} service${count > 1 ? 's' : ''}`
                          : <span style={{ color: '#CBD5E1', fontStyle: 'italic' }}>Aucun service</span>
                        }
                      </div>
                      <button
                        onClick={() => handleDeleteCategory(cat)}
                        title={hasServices
                          ? `Supprimer "${cat}" (${count} service${count > 1 ? 's' : ''} associé${count > 1 ? 's' : ''})`
                          : `Supprimer "${cat}"`}
                        style={{
                          position: 'absolute', top: 12, right: 12,
                          background: hasServices ? '#FFF7ED' : '#FEF2F2',
                          border: `1px solid ${hasServices ? '#FED7AA' : '#FECACA'}`,
                          color: hasServices ? '#EA580C' : '#DC2626',
                          borderRadius: 6, width: 26, height: 26,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: 13, cursor: 'pointer', flexShrink: 0, transition: 'opacity .15s',
                        }}
                        onMouseEnter={e => e.currentTarget.style.opacity = '0.75'}
                        onMouseLeave={e => e.currentTarget.style.opacity = '1'}
                      >
                        🗑️
                      </button>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* CORBEILLE */}
        {paramTab === 'corbeille' && (
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: C.navy, marginBottom: 4 }}>
              🗑️ Corbeille
            </div>
            <div style={{ fontSize: 12, color: '#94A3B8', marginBottom: 20 }}>
              {deletedServices.length} service(s) supprimé(s)
            </div>

            {deletedServices.length === 0 ? (
              <div style={{ color: '#94A3B8', fontSize: 13, textAlign: 'center', paddingTop: 40 }}>
                La corbeille est vide
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                    {['Nom', 'Catégorie', 'Supprimé le', ''].map(h => (
                      <th key={h} style={{ padding: '8px 10px', textAlign: 'left',
                                           fontSize: 10, fontWeight: 600, color: '#94A3B8',
                                           textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {deletedServices.map(svc => (
                    <tr key={svc.id} style={{ borderBottom: '1px solid #F8FAFC' }}>
                      <td style={{ padding: '10px 10px', fontWeight: 600, color: '#64748B' }}>{svc.name}</td>
                      <td style={{ padding: '10px 10px', color: '#94A3B8' }}>{svc.category}</td>
                      <td style={{ padding: '10px 10px', color: '#94A3B8', fontSize: 11 }}>
                        {svc.deleted_at ? new Date(svc.deleted_at).toLocaleDateString('fr-FR') : '—'}
                      </td>
                      <td style={{ padding: '10px 10px', display: 'flex', gap: 6 }}>
                        <button
                          onClick={() => onRestore(svc.id)}
                          style={{ background: '#DCFCE7', border: '1px solid #BBF7D0',
                                    color: '#16A34A', borderRadius: 6, padding: '4px 10px',
                                    fontSize: 11, cursor: 'pointer' }}>
                          ↩ Restaurer
                        </button>
                        <button
                          onClick={() => onDeletePermanent(svc.id)}
                          style={{ background: '#FEF2F2', border: '1px solid #FECACA',
                                    color: '#DC2626', borderRadius: 6, padding: '4px 10px',
                                    fontSize: 11, cursor: 'pointer' }}>
                          🗑️ Supprimer
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* UTILISATEURS */}
        {paramTab === 'utilisateurs' && user?.role === 'admin' && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div>
                <div style={{ fontSize: 16, fontWeight: 700, color: C.navy }}>👥 Utilisateurs</div>
                <div style={{ fontSize: 12, color: '#94A3B8', marginTop: 2 }}>{users.length} utilisateur(s)</div>
              </div>
              <button
                onClick={() => setShowAddUser(true)}
                style={{ background: C.blue, color: '#fff', border: 'none', borderRadius: 8,
                         padding: '8px 16px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                + Nouvel utilisateur
              </button>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #F1F5F9' }}>
                  {['Nom', 'Email', 'Rôle', 'Statut', ''].map(h => (
                    <th key={h} style={{ padding: '8px 10px', textAlign: 'left',
                      fontSize: 10, fontWeight: 600, color: '#94A3B8',
                      textTransform: 'uppercase', letterSpacing: 0.5 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.id} style={{ borderBottom: '1px solid #F8FAFC' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#F8FAFC'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px', fontWeight: 600, color: C.navy }}>{u.full_name}</td>
                    <td style={{ padding: '10px', color: '#64748B' }}>{u.email}</td>
                    <td style={{ padding: '10px' }}>
                      <span style={{
                        background: u.role === 'admin' ? '#EFF6FF' : '#F1F5F9',
                        color:       u.role === 'admin' ? C.blue    : '#64748B',
                        borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 600,
                      }}>
                        {u.role === 'admin' ? 'Admin' : u.role === 'operator' ? 'Opérateur' : 'Viewer'}
                      </span>
                    </td>
                    <td style={{ padding: '10px' }}>
                      <span style={{
                        background: u.active ? '#DCFCE7' : '#FEE2E2',
                        color:       u.active ? '#16A34A' : '#DC2626',
                        borderRadius: 4, padding: '2px 8px', fontSize: 11, fontWeight: 600,
                      }}>
                        {u.active ? 'Actif' : 'Inactif'}
                      </span>
                    </td>
                    <td style={{ padding: '10px', display: 'flex', gap: 6 }}>
                      <button
                        onClick={() => setEditUser(u)}
                        style={{ background: '#F8FAFC', border: '1px solid #E2E8F0',
                                  color: C.navy, borderRadius: 6, padding: '4px 10px',
                                  fontSize: 11, cursor: 'pointer' }}>
                        ✏️ Modifier
                      </button>
                 <button
                    onClick={() => setDeleteUserModal(u.id)}
                    style={{ background: '#FEF2F2', border: '1px solid #FECACA',
                              color: '#DC2626', borderRadius: 6, padding: '4px 10px',
                              fontSize: 11, cursor: 'pointer' }}>
                    🗑️
                  </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Modal Ajouter un utilisateur */}
            {showAddUser && (
              <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                <div style={{ background: '#fff', width: 440, borderRadius: 14, padding: 24,
                              boxShadow: '0 10px 40px rgba(0,0,0,.2)' }}>
                  <div style={{ fontSize: 18, fontWeight: 700, color: C.navy, marginBottom: 16 }}>
                    👤 Nouvel utilisateur
                  </div>
                  {[
                    { label: 'Nom complet',   key: 'fullName',  type: 'text'     },
                    { label: 'Email',          key: 'email',     type: 'email'    },
                    { label: 'Mot de passe',   key: 'password',  type: 'password' },
                  ].map(({ label, key, type }) => (
                    <div key={key} style={{ marginBottom: 12 }}>
                      <label style={{ fontSize: 12, color: '#64748B', display: 'block', marginBottom: 4 }}>{label}</label>
                      <input
                        type={type}
                        value={newUser[key]}
                        onChange={e => setNewUser(p => ({ ...p, [key]: e.target.value }))}
                        style={{ width: '100%', border: '1px solid #E2E8F0', borderRadius: 8,
                                  padding: '8px 12px', fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
                    </div>
                  ))}
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ fontSize: 12, color: '#64748B', display: 'block', marginBottom: 4 }}>Rôle</label>
                    <select
                      value={newUser.role}
                      onChange={e => setNewUser(p => ({ ...p, role: e.target.value }))}
                      style={{ width: '100%', border: '1px solid #E2E8F0', borderRadius: 8,
                                padding: '8px 12px', fontSize: 13, outline: 'none' }}>
                      <option value="admin">Admin</option>
                      <option value="operator">Opérateur </option>
                      <option value="viewer">Viewer</option>
                    </select>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                    <button
                      onClick={() => { setShowAddUser(false); setNewUser({ fullName: '', email: '', password: '', role: 'operator' }); }}
                      style={{ border: '1px solid #E2E8F0', background: '#fff',
                               padding: '9px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
                      Annuler
                    </button>
                    <button
                      onClick={async () => {
                        try {
                      const res = await createUser({
                      full_name: newUser.fullName,
                      email:     newUser.email,
                      password:  newUser.password,
                      role:      newUser.role,
                     });
                    const created = res.data?.data ?? res.data;
                    setUsers(p => [...p, created]);
                    setShowAddUser(false);  
                    setNewUser({ fullName: '', email: '', password: '', role: 'operator' });   
                  } catch (err) { console.error(err); }
                }}

                      style={{ background: C.blue, color: '#fff', border: 'none',
                               padding: '9px 16px', borderRadius: 8, cursor: 'pointer',
                               fontSize: 13, fontWeight: 600 }}>
                      Créer
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Modal Modifier un utilisateur */}
            {editUser && (
              <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                <div style={{ background: '#fff', width: 440, borderRadius: 14, padding: 24,
                              boxShadow: '0 10px 40px rgba(0,0,0,.2)' }}>
                  <div style={{ fontSize: 18, fontWeight: 700, color: C.navy, marginBottom: 16 }}>
                    ✏️ Modifier l'utilisateur
                  </div>
                  {[
                    { label: 'Nom complet', key: 'full_name', type: 'text'  },
                    { label: 'Email',       key: 'email',     type: 'email' },
                  ].map(({ label, key, type }) => (
                    <div key={key} style={{ marginBottom: 12 }}>
                      <label style={{ fontSize: 12, color: '#64748B', display: 'block', marginBottom: 4 }}>{label}</label>
                      <input
                        type={type}
                        value={editUser[key] || ''}
                        onChange={e => setEditUser(p => ({ ...p, [key]: e.target.value }))}
                        style={{ width: '100%', border: '1px solid #E2E8F0', borderRadius: 8,
                                  padding: '8px 12px', fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
                    </div>
                  ))}
                  <div style={{ marginBottom: 12 }}>
                    <label style={{ fontSize: 12, color: '#64748B', display: 'block', marginBottom: 4 }}>Rôle</label>
                    <select
                      value={editUser.role}
                      onChange={e => setEditUser(p => ({ ...p, role: e.target.value }))}
                      style={{ width: '100%', border: '1px solid #E2E8F0', borderRadius: 8, padding: '8px 12px', fontSize: 13 }}>
                      <option value="admin">Admin</option>
                      <option value="operator">Opérateur</option>
                      <option value="viewer">Viewer</option>
                    </select>
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ fontSize: 12, color: '#64748B', display: 'block', marginBottom: 4 }}>Statut</label>
                    <select
                      value={editUser.active ? 'active' : 'inactive'}
                      onChange={e => setEditUser(p => ({ ...p, active: e.target.value === 'active' }))}
                      style={{ width: '100%', border: '1px solid #E2E8F0', borderRadius: 8, padding: '8px 12px', fontSize: 13 }}>
                      <option value="active">Actif</option>
                      <option value="inactive">Inactif</option>
                    </select>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                    <button
                      onClick={() => setEditUser(null)}
                      style={{ border: '1px solid #E2E8F0', background: '#fff',
                               padding: '9px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
                      Annuler
                    </button>
                    <button
                      onClick={async () => {
                      try {
                        const res = await updateUser(editUser.id, editUser);
                        const updated = res.data?.data ?? res.data;  
                        setUsers(p => p.map(u => u.id === editUser.id ? updated : u));
                        setEditUser(null);
                      } catch (err) { console.error(err); }
                    }}
                      style={{ background: C.blue, color: '#fff', border: 'none',
                               padding: '9px 16px', borderRadius: 8, cursor: 'pointer',
                               fontSize: 13, fontWeight: 600 }}>
                      Enregistrer
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {/* Modal confirmation suppression utilisateur */}
{deleteUserModal && (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
    <div style={{ background: '#fff', width: 420, borderRadius: 14, padding: 24,
                  boxShadow: '0 10px 40px rgba(0,0,0,.2)' }}>
      <div style={{ fontSize: 20, fontWeight: 700, color: '#1B2A4A', marginBottom: 10 }}>
        🗑️ Supprimer l'utilisateur
      </div>
      <div style={{ color: '#64748B', fontSize: 14, marginBottom: 24 }}>
        Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
        <button
          onClick={() => setDeleteUserModal(null)}
          style={{ border: '1px solid #E2E8F0', background: '#fff',
                   padding: '10px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
          Annuler
        </button>
        <button
          onClick={async () => {
            try {
              await deleteUser(deleteUserModal);
              setUsers(prev => prev.filter(x => x.id !== deleteUserModal));
              setDeleteUserModal(null);
            } catch (err) { console.error(err); }
          }}
          style={{ background: '#DC2626', color: '#fff', border: 'none',
                   padding: '10px 16px', borderRadius: 8, cursor: 'pointer',
                   fontSize: 13, fontWeight: 600 }}>
          Supprimer
        </button>
      </div>
    </div>
  </div>
)}

      </div>

      {/* ── Modal suppression catégorie ── */}
      {deleteCatModal && categoryToDelete && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <div style={{ background: '#fff', width: 440, borderRadius: 14, padding: 24,
                        boxShadow: '0 10px 40px rgba(0,0,0,.2)' }}>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#1B2A4A', marginBottom: 10 }}>
              🗂️ Supprimer la catégorie
            </div>

            {serviceCountForCat(categoryToDelete) > 0 ? (
              <>
                <div style={{ background: '#FFF7ED', border: '1px solid #FED7AA', borderRadius: 8,
                              padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#7C2D12',
                              display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: 16, flexShrink: 0 }}>⚠️</span>
                  <span>
                    La catégorie <strong>"{categoryToDelete}"</strong> est utilisée par{' '}
                    <strong>{serviceCountForCat(categoryToDelete)} service(s)</strong>.
                    Ces services n'auront plus de catégorie après la suppression.
                  </span>
                </div>
                <div style={{ color: '#64748B', fontSize: 14, marginBottom: 24 }}>
                  Voulez-vous quand même supprimer cette catégorie ?
                </div>
              </>
            ) : (
              <div style={{ color: '#64748B', fontSize: 14, marginBottom: 24 }}>
                Êtes-vous sûr de vouloir supprimer la catégorie <strong>"{categoryToDelete}"</strong> ?
                Cette action est irréversible.
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <button
                onClick={() => { setDeleteCatModal(false); setCategoryToDelete(null); }}
                style={{ border: '1px solid #E2E8F0', background: '#fff',
                         padding: '10px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
                Annuler
              </button>
              <button
                onClick={confirmDeleteCategory}
                style={{ background: '#DC2626', color: '#fff', border: 'none',
                         padding: '10px 16px', borderRadius: 8, cursor: 'pointer',
                         fontSize: 13, fontWeight: 600 }}>
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ── Dashboard principal ───────────────────────────────────────────────────── */
export default function Dashboard({ user, onLogout }) {
  const navigate = useNavigate();

  const [tab,             setTab]             = useState('apps');
  const [services,        setServices]        = useState([]);
  const [deletedServices, setDeletedServices] = useState([]);
  const [slaData,         setSlaData]         = useState(null);
  const [maintenances,    setMaintenances]    = useState([]);
  const [logs,            setLogs]            = useState([]);
  const [loading,         setLoading]         = useState(true);
  const [clock,           setClock]           = useState('');
  const [search,          setSearch]          = useState('');
  const [deleteModal,     setDeleteModal]     = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editServiceId,   setEditServiceId]   = useState(null);

  useEffect(() => {
    const tick = () => setClock(new Date().toLocaleTimeString('fr-FR'));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, []);

  const loadAll = useCallback(async () => {
    try {
      const [svcRes, slaRes, maintRes, logsRes, deletedRes] = await Promise.allSettled([
        getServices(),
        getSlaReport(new Date().toISOString().slice(0, 7)),
        getMaintenances(),
        getLogs({ limit: 50 }),
        getDeletedServices(),
      ]);

      if (svcRes.status   === 'fulfilled') setServices(svcRes.value.data?.data ?? svcRes.value.data ?? []);
      if (slaRes.status   === 'fulfilled') setSlaData(slaRes.value.data);
      if (maintRes.status === 'fulfilled') setMaintenances(maintRes.value.data?.data ?? maintRes.value.data ?? []);

      if (deletedRes.status === 'fulfilled') {
        const raw = deletedRes.value.data;
        const list = Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : [];
        setDeletedServices(list);
      } else {
        console.error('Erreur getDeletedServices:', deletedRes.reason);
      }

      if (logsRes.status === 'fulfilled') {
        const dbLogs = (logsRes.value.data?.data ?? []).map((l) => ({
          level: l.type, service: l.service_name,
          message: l.message, ts: l.created_at,
        }));
        setLogs(dbLogs);
      }
    } catch (err) {
      console.error('loadAll error:', err);
    }
    setLoading(false);
  }, []);

  useEffect(() => { loadAll(); }, [loadAll]);

  useSocket(['dashboard', 'logs'], {
    service_update: useCallback((data) => {
      setServices((prev) =>
        prev.map((s) => s.id === data.serviceId
          ? { ...s, last_status: data.status, last_response_ms: data.responseMs } : s)
      );
    }, []),
    log_entry: useCallback((entry) => {
      setLogs((prev) => [entry, ...prev].slice(0, 300));
    }, []),
  });

  const total       = services.length;
  const active      = services.filter((s) => s.last_status === 'OK').length;
  const alerts      = services.filter((s) => ['DOWN', 'WARN'].includes(s.last_status)).length;
  const globalAvail = slaData?.kpis?.globalAvailability ?? '—';
  const avgResp     = services.filter((s) => s.last_response_ms).length
    ? Math.round(services.reduce((s, x) => s + (x.last_response_ms || 0), 0) / services.filter((x) => x.last_response_ms).length)
    : '—';

  const filteredServices = services.filter(s =>
    s.name?.toLowerCase().includes(search.toLowerCase())
  );
  const groups = groupByCategory(filteredServices);

  const handleDelete = (id) => { setServiceToDelete(id); setDeleteModal(true); };

  const confirmDelete = async () => {
    try {
      await deleteService(serviceToDelete);
      const removed = services.find(s => s.id === serviceToDelete);
      if (removed) {
        setDeletedServices(prev => [...prev, { ...removed, deleted_at: new Date().toISOString() }]);
      }
      setServices(prev => prev.filter(s => s.id !== serviceToDelete));
      setDeleteModal(false);
      setServiceToDelete(null);
    } catch (err) { console.error(err); }
  };

  const handleRestore = async (id) => {
    try {
      await restoreService(id);
      const svc = deletedServices.find(s => s.id === id);
      if (svc) {
        setServices(prev => [...prev, { ...svc, deleted_at: null }]);
        setDeletedServices(prev => prev.filter(s => s.id !== id));
      }
    } catch (err) { console.error(err); }
  };

  const handleDeletePermanent = async (id) => {
    try {
      await hardDeleteService(id);
      setDeletedServices(prev => prev.filter(s => s.id !== id));
    } catch (err) { console.error(err); }
  };

  const handleToggleActive = (id, newActive) => {
    setServices(prev =>
      prev.map(s => s.id === id ? { ...s, active: newActive } : s)
    );
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: C.navy, display: 'flex',
                    alignItems: 'center', justifyContent: 'center',
                    color: C.gold, fontSize: 18, fontFamily: 'sans-serif' }}>
        Chargement de Monitor…
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: C.surface, fontFamily: "'Segoe UI', sans-serif" }}>

      {/* Topbar */}
      <div style={{ background: C.navy, height: 52, display: 'flex', alignItems: 'center',
                    justifyContent: 'space-between', padding: '0 20px',
                    borderBottom: `2px solid ${C.gold}` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 32, height: 32, background: C.blue, borderRadius: 7,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontWeight: 700, color: '#fff', fontSize: 13 }}>RI</div>
          <div>
            <div style={{ color: '#fff', fontSize: 15, fontWeight: 600, letterSpacing: 0.5 }}>
              MONITOR <span style={{ color: C.gold, fontSize: 11, fontWeight: 400 }}>by RevealIT</span>
            </div>
            <div style={{ color: C.gold, fontSize: 9, textTransform: 'uppercase', letterSpacing: 1.5 }}>
              Infrastructure Supervision Platform
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: 5, background: 'rgba(22,163,74,.2)',
                         border: '1px solid rgba(22,163,74,.4)', borderRadius: 20,
                         padding: '3px 10px', color: '#4ADE80', fontSize: 11 }}>
            <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#4ADE80',
                           animation: 'pulse 1.5s infinite' }} />
            LIVE
          </span>
          <span style={{ color: 'rgba(255,255,255,.5)', fontSize: 11 }}>{clock}</span>
          <button onClick={() => { onLogout(); }}
            style={{ color: '#fff', fontSize: 12, cursor: 'pointer', opacity: 0.7,
                     background: 'none', border: 'none', padding: 0 }}>
            {user?.fullName ?? 'Utilisateur'}
          </button>
        </div>
      </div>

      {/* KPIs */}
      <div style={{ background: C.navy, display: 'grid', gridTemplateColumns: 'repeat(5,1fr)',
                    borderBottom: '1px solid rgba(201,168,76,.3)' }}>
        {[
          { label: 'Disponibilité globale', value: `${globalAvail}%`, color: '#4ADE80', sub: '30 derniers jours' },
          { label: 'Services actifs',       value: `${active}/${total}`, color: '#fff', sub: `${alerts} en alerte` },
          { label: 'Incidents actifs',      value: alerts, color: alerts ? '#FB923C' : '#4ADE80', sub: 'ce mois' },
          { label: 'Temps réponse moy.',    value: `${avgResp} ms`, color: C.gold, sub: 'tous services' },
          { label: 'Maintenances à venir',  value: maintenances.filter(m => m.status === 'planned').length, color: '#fff', sub: 'planifiées' },
        ].map(({ label, value, color, sub }) => (
          <div key={label} style={{ padding: '10px 16px', textAlign: 'center',
                                    borderRight: '1px solid rgba(255,255,255,.08)' }}>
            <div style={{ color: 'rgba(255,255,255,.45)', fontSize: 9, textTransform: 'uppercase',
                          letterSpacing: 1, marginBottom: 3 }}>{label}</div>
            <div style={{ fontSize: 20, fontWeight: 700, color, lineHeight: 1 }}>{value}</div>
            <div style={{ color: 'rgba(255,255,255,.3)', fontSize: 9, marginTop: 2 }}>{sub}</div>
          </div>
        ))}
      </div>

      {/* Navigation */}
      <div style={{ background: '#fff', borderBottom: '1px solid #E2E8F0',
                    padding: '0 16px', display: 'flex', overflowX: 'auto' }}>
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding: '10px 16px', fontSize: 12, fontWeight: 500,
                     color: tab === t.id ? C.blue : C.gray, border: 'none',
                     background: 'none', borderBottom: tab === t.id ? `2px solid ${C.blue}` : '2px solid transparent',
                     cursor: 'pointer', whiteSpace: 'nowrap', marginBottom: -1 }}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Contenu */}
      <div style={{ padding: 16 }}>

        {tab === 'apps' && (
          <div>
            {alerts > 0 && (
              <div style={{ background: '#FFF7ED', border: '1px solid #FED7AA', borderRadius: 8,
                            padding: '10px 14px', marginBottom: 12, fontSize: 12,
                            display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                <span style={{ fontSize: 16 }}>⚠️</span>
                <span style={{ color: '#7C2D12' }}>
                  <strong>{alerts} service(s) en alerte.</strong> Vérifiez les logs pour plus de détails.
                </span>
              </div>
            )}
            <div style={{ marginBottom: 14 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#fff',
                            border: '1px solid #E2E8F0', borderRadius: 8, padding: '6px 12px', width: 280 }}>
                <span style={{ fontSize: 14, color: '#94A3B8' }}>🔍</span>
                <input type="text" placeholder="Rechercher un service…" value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ border: 'none', outline: 'none', fontSize: 12,
                           color: '#1B2A4A', background: 'transparent', width: '100%' }} />
              </div>
            </div>

            {Object.entries(groups).map(([cat, svcs]) => (
              <div key={cat}>
                <div style={{ fontSize: 10, fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase',
                              letterSpacing: 1, margin: '14px 0 7px', display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ width: 3, height: 13, background: C.gold, borderRadius: 2 }} />
                  {cat}
                  <span style={{ flex: 1, height: 1, background: '#F1F5F9' }} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 8 }}>
                  {svcs.map((svc) => (
                    <ServiceCard
                      key={svc.id}
                      service={svc}
                      onDelete={handleDelete}
                      onToggleActive={handleToggleActive}
                      onEdit={(id) => setEditServiceId(id)}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {tab === 'apis' && (
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: C.navy, textTransform: 'uppercase',
                          letterSpacing: 1, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
              <span style={{ width: 3, height: 12, background: C.gold, borderRadius: 2 }} />
              APIs & Endpoints supervisés
            </div>
            {services.map((svc) => <ApiCard key={svc.id} service={svc} />)}
          </div>
        )}

        {tab === 'logs' && <LogTerminal logs={logs} />}

        {tab === 'cal' && (
          <CalendarView
            maintenances={maintenances}
            services={services}
            onCreated={async () => {
              const res = await getMaintenances();
              setMaintenances(res.data?.data ?? res.data ?? []);
            }}
            onDeleted={(id) => {
              setMaintenances(prev => prev.filter(m => m.id !== id));
            }}
            onStatusUpdated={(id, newStatus) => {
              setMaintenances(prev =>
                prev.map(m => m.id === id ? { ...m, status: newStatus } : m)
              );
            }}
          />
        )}

        {tab === 'sla' && <SlaReport data={slaData} />}

        {tab === 'parametres' && (
          <ParametresTab
            user={user}
            services={services}
            deletedServices={deletedServices}
            onDelete={handleDelete}
            onRestore={handleRestore}
            onDeletePermanent={handleDeletePermanent}
            onCreateService={() => setShowCreateModal(true)}
          />
        )}
      </div>

      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }
        * { box-sizing: border-box; }
      `}</style>

      {/* Modal suppression service */}
      {deleteModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
          <div style={{ background: '#fff', width: 420, borderRadius: 14, padding: 24,
                        boxShadow: '0 10px 40px rgba(0,0,0,.2)' }}>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#1B2A4A', marginBottom: 10 }}>
              🗑️ Supprimer le service
            </div>
            <div style={{ color: '#64748B', fontSize: 14, marginBottom: 24 }}>
              Êtes-vous sûr de vouloir supprimer ce service ? Il sera déplacé dans la corbeille.
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <button onClick={() => setDeleteModal(false)}
                style={{ border: '1px solid #E2E8F0', background: '#fff',
                         padding: '10px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}>
                Annuler
              </button>
              <button onClick={confirmDelete}
                style={{ background: '#DC2626', color: '#fff', border: 'none',
                         padding: '10px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
                Supprimer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal CreateService */}
      {showCreateModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999, padding: 16,
        }}>
          <CreateServiceModal
            onClose={() => setShowCreateModal(false)}
            onCreated={(newSvc) => {
              setServices(prev => [...prev, newSvc]);
              setShowCreateModal(false);
            }}
          />
        </div>
      )}

      {editServiceId && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 9999, padding: 16,
        }}>
          <EditServiceModal
            serviceId={editServiceId}
            onClose={() => setEditServiceId(null)}
            onUpdated={(updatedSvc) => {
              setServices(prev =>
                prev.map(s => s.id === updatedSvc.id ? updatedSvc : s)
              );
              setEditServiceId(null);
            }}
          />
        </div>
      )}
    </div>
  );
} 